{
  "pt_BR": "festa",
  "cs_CZ": "patek",
  "da_DK": "fest",
  "de_DE": "party",
  "en_GB": "party",
  "es_ES": "fiesta",
  "fi_FI": "juhla",
  "fr_FR": "soiree",
  "it_IT": "festa",
  "ja_JP": "pa-ti",
  "ko_KR": "pati",
  "nl_NL": "feest",
  "nb_NO": "fest",
  "pl_PL": "impreza",
  "pt_PT": "festa",
  "ru_RU": "vechirinka",
  "sv_SE": "fest",
  "tr_TR": "parti",
  "zh_CN": "pai-dang"
}
